import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import InterestedPersonIcon from '@/svg-icons/InterestedPerson';

const InterestedPersonSection = ({ data }) => (
  <div className="w-full">
    <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
      <InterestedPersonIcon className="text-gray-700 mr-2 w-6 h-6 shrink-0" />
      <FormattedMessage id="interestedPerson" />
    </div>

    <div className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
      <div className="w-1/2 mb-[1vw]" data-cy="order-details-interested-person-full-name">
        <div className="font-bold">
          <FormattedMessage id="fullName" />
        </div>
        {data.fullName}
      </div>

      <div className="w-1/2 mb-[1vw]" data-cy="order-details-interested-person-whatsapp">
        <div className="font-bold">
          <FormattedMessage id="whatsapp" />
        </div>
        {data.whatsapp}
      </div>
    </div>
  </div>
);

InterestedPersonSection.propTypes = {
  data: PropTypes.object.isRequired,
};

export default InterestedPersonSection;
